import { ReactNode } from "react";
import { useAuth } from "@/features/auth/model/AuthContext";
import { Navigate } from "react-router-dom";
import { Permission } from "@/shared/types/roles";

interface ProtectedRouteProps {
  children: ReactNode;
  permissions?: Permission[];
  redirectTo?: string;
}

export function ProtectedRoute({
  children,
  permissions = [],
  redirectTo = "/auth"
}: ProtectedRouteProps) {
  const { isAuthenticated, loading, hasPermission } = useAuth();

  // Se ainda está carregando, mostra loading
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1A1A1A] text-white">
        Carregando...
      </div>
    );
  }

  // Se não está autenticado, redireciona para login
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // Se tem permissões específicas, verifica se o usuário tem pelo menos uma
  if (permissions.length > 0) {
    const hasAccess = permissions.some(permission => hasPermission(permission));
    if (!hasAccess) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
}